import {
  DecorationShallowNode,
  FAreaShallowNode,
  FCompositionShallowNode,
  FPolygonShallowNode,
  FShallowNode,
  FShallowNodeTypesEnum,
  FurnitureShallowNode,
} from '@spazious/dollhouse-shallow-graph';

import { FNode, FNodeTypesEnum } from '../types/index.js';

/**
 * This function extracts the minimal data to create
 * the sallow representation of the node passed by arg
 */
export const convertNodeToShallow = <TNode extends FNode, RNode extends FShallowNode>(
  node: TNode
): RNode => {
  switch (node.type) {
    case FNodeTypesEnum.Furniture: {
      return {
        id: node.id,
        type: FShallowNodeTypesEnum.Furniture,
        selector: node.selector,
        position: node.position,
        rotation: node.rotation,
        visible: node.visible,
      } as FurnitureShallowNode as RNode;
    }
    case FNodeTypesEnum.FComposition: {
      return {
        id: node.id,
        type: FShallowNodeTypesEnum.FComposition,
        selector: node.selector,
        position: node.position,
        rotation: node.rotation,
        attrs: node.shallow?.attrs,
      } as FCompositionShallowNode as RNode;
    }
    case FNodeTypesEnum.FArea: {
      return {
        type: FShallowNodeTypesEnum.FArea,
        selector: node.selector,
        points: node.shallow?.points,
      } as FAreaShallowNode as RNode;
    }
    case FNodeTypesEnum.FPolygon: {
      return {
        type: FShallowNodeTypesEnum.FPolygon,
        id: node.id,
        selector: node.selector,
        position: node.position,
        rotation: node.rotation,
        points: node.shallow?.points,
      } as FPolygonShallowNode as RNode;
    }
    case FNodeTypesEnum.Decoration: {
      return {
        type: FShallowNodeTypesEnum.Decoration,
        id: node.id,
        selector: node.selector,
        position: node.position,
        rotation: node.rotation,
        visible: node.visible,
      } as DecorationShallowNode as RNode;
    }
    case FNodeTypesEnum.FGroup: {
      throw new Error('FGroup can be defined as shallow nodes');
    }
    default: {
      throw new TypeError(`Unkown node type ${(node as any).type}`);
    }
  }
};
